/**
 * AÏNN London - Cart Validation
 * Ensures add-on products can only be purchased with a main outfit
 * 
 * Add to theme.liquid before </body> or as an asset
 */

(function() {
  'use strict';

  // Add-on product handles - these cannot be purchased alone
  const ADDON_HANDLES = [
    'matching-chiffon-hijab-add-on',
    'matching-potli-bag-add-on', 
    'heavier-embroidery-dupatta-add-on'
  ];

  // Check if a cart item is an add-on
  function isAddonProduct(item) {
    return ADDON_HANDLES.includes(item.handle);
  }

  // Check if cart has any main products (non-add-ons)
  function hasMainProduct(cartItems) {
    return cartItems.some(item => !isAddonProduct(item));
  }

  // Remove an item from cart
  async function removeFromCart(itemKey) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      });
      return await response.json();
    } catch (error) {
      console.error('[CART-VALIDATION] Error removing item:', error);
      return null;
    }
  }

  // Validate cart and remove orphan add-ons
  async function validateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (!cart.items || cart.items.length === 0) {
        return;
      }

      const hasMain = hasMainProduct(cart.items);
      
      // If no main product, remove all add-ons
      if (!hasMain) {
        const addonsInCart = cart.items.filter(item => isAddonProduct(item));
        
        if (addonsInCart.length > 0) {
          console.log('[CART-VALIDATION] No main product found, removing orphan add-ons');
          
          // Remove each add-on
          for (const addon of addonsInCart) {
            await removeFromCart(addon.key);
          }
          
          // Show message to user
          showNotification('Add-on items require a main outfit. They have been removed from your cart.');
          
          // Refresh the page to update cart display
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      }
    } catch (error) {
      console.error('[CART-VALIDATION] Error validating cart:', error);
    }
  }

  // Show notification to user
  function showNotification(message) {
    // Try to use existing notification system
    if (typeof window.showToast === 'function') {
      window.showToast(message);
      return;
    }
    
    // Create custom notification
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #1a1a1a;
      color: #fff;
      padding: 16px 24px;
      border-radius: 4px;
      font-family: inherit;
      font-size: 14px;
      z-index: 99999;
      max-width: 90%;
      text-align: center;
      box-shadow: 0 4px 20px rgba(0,0,0,0.3);
    `;
    notification.textContent = message;
    document.body.appendChild(notification);
    
    // Remove after 5 seconds
    setTimeout(() => {
      notification.remove();
    }, 5000);
  }

  // Run validation on page load
  document.addEventListener('DOMContentLoaded', function() {
    // Only run on cart page and checkout
    const isCartPage = window.location.pathname.includes('/cart');
    const isCheckout = window.location.pathname.includes('/checkout');
    
    if (isCartPage || isCheckout) {
      validateCart();
    }
  });

  // Also validate when cart drawer opens (if applicable)
  document.addEventListener('cart:open', validateCart);
  document.addEventListener('cart:updated', validateCart);
  
  // Listen for cart changes via AJAX
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const result = originalFetch.apply(this, args);
    
    // Check if this was a cart modification
    if (args[0] && typeof args[0] === 'string') {
      if (args[0].includes('/cart/change') || args[0].includes('/cart/update')) {
        result.then(() => {
          // Delay to let cart update complete
          setTimeout(validateCart, 500);
        });
      }
    }
    
    return result;
  };

})();